<template>
  <div class="vat-preview-table-wrapper">
    <EInvoiceVatTables
      :items="items"
      :summary="summary"
      preview-mode
      show-product-image
      :goods-table-max-height="280"
      :emphasize-summary-total="false"
    />
  </div>
</template>

<script>
  import EInvoiceVatTables from '../EInvoiceVatTables.vue'

  export default {
    name: 'VatPreviewTable',

    components: {
      EInvoiceVatTables,
    },

    props: {
      items: {
        type: Array,
        required: true,
        default: () => [],
      },
      summary: {
        type: Object,
        required: true,
        default: () => ({}),
      },
    },
  }
</script>

<style lang="scss" scoped>
  .vat-preview-table-wrapper {
    background: #fff;
  }
</style>
